<div class="mb-4">
    <h2 i18n>
      <a [routerLink]="['/']">
        <i class="fa-solid fa-house fa-xs page-name-separator" aria-hidden="true"></i>
      </a>
      Account Management
    </h2>
  </div>

  <div class="center">
      <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
  </div>
  
<form #accountForm="ngForm">
  <fieldset [disabled]="!accountBeingEdited">
    <div class="form-row row">

      <!--div class="ui-g-1"-->
        <div class="mb-3 col-md-1">
          <label class="disabled form-label" for="accountId">Account ID</label>
          <input type="text" class="form-control" id="accountId" disabled [ngModel]="selectedAccountCopy.accountId"
                 name="accountId"
                 placeholder="Account ID" #accountId="ngModel">
        </div>
      <!--/div-->

      <!--div class="ui-g-2"-->
        <div class="mb-3 col-md-2">
          <label class="disabled form-label" for="companyName">Company Name</label>
          <input autocomplete='organization' type="text" class="form-control" id="companyName" disabled
                 [ngModel]="selectedAccountCopy.companyName" name="companyName"
                 placeholder="company Name" #companyName="ngModel">
        </div>
      <!--/div-->

      <!--div class="ui-g-1"-->
        <div class="mb-3 col-md-1">
          <label class="form-label" for="spid">SPID</label>
          <input type="text" class="form-control" id="spid" [ngModel]="selectedAccountCopy.spid" name="spid"
                 placeholder="xxxx"
                 #spid="ngModel">
        </div>
      <!--/div-->

      <!--div class="ui-g-2"-->
        <div class="mb-3 col-md-2">
          <label class="form-label" for="purchaseOrderNumber">Purchase Order Number</label>
          <input autocomplete='purchaseOrderNumber' type="text" class="form-control" id="purchaseOrderNumber"
                 [(ngModel)]="selectedAccountCopy.purchaseOrderNumber" name="purchaseOrderNumber"
                 #purchaseOrderNumber="ngModel">
        </div>
      <!--/div-->
      <div class="col-md-1" *ngIf="selectedAccountCopy.contractType === 'clickThru'">
        <div><label>&nbsp;</label></div>

          <div>
            <a class="edit-link" href="{{serviceAgreementUrl+selectedAccountCopy.serviceAgreementVersion}}">Service Agreement</a>
          </div>
        </div>

    </div>

    <div>
      <strong>Account Contact Information</strong>
    </div>
    <div class="ui-g">

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="required form-label" for="firstName">First Name</label>
          <input autocomplete='given-name' type="text" class="form-control" id="firstName" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.firstName"
                 name="firstName" #firstName="ngModel">
        </div>

        <div class="mb-3">
          <label class="required form-label" for="lastName">Last Name</label>
          <input autocomplete='family-name' type="text" class="form-control" id="lastName" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.lastName"
                 name="lastName" #lastName="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="required form-label" for="email">Email Address</label>
          <input autocomplete='email' type="text" class="form-control" id="email" required emailvalidator
                 [(ngModel)]="selectedAccountCopy.email"
                 name="email" placeholder="email@domain.com" #email="ngModel">
        </div>

        <div class="mb-3">
          <label class="form-label" for="phone">Telephone Number</label>
          <input autocomplete='tel-national' type="text" class="form-control" id="phone"
                  [(ngModel)]="selectedAccountCopy.phone" minlength="7"
                 name="phone" #phone="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="form-label" for="country">Country</label>
          <div class="input-group">
            <p-dropdown autocomplete='country-name' #country id="country" placeholder="Select" 
                        [filter]="true" [style]="{'width': '100%'}" iuiDropdown
                        class="p-formcontrol" [(ngModel)]="selectedAccountCopy.country" iuiCountry [region]="state"
                        [name]="'country'" [disabled]="!accountBeingEdited"></p-dropdown>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="address1">Address 1</label>
          <input autocomplete='address-line1' type="text" class="form-control" id="address1"
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.address1"
                 name="address1" placeholder="street address" #address1="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="form-label" for="address2">Address 2</label>
          <input autocomplete='address-line2' type="text" class="form-control" id="address2"
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.address2"
                 name="address2" placeholder="suite, floor, etc." #address2="ngModel">
        </div>

        <div class="mb-3">
          <label class="form-label" for="city">City</label>
          <input autocomplete='address-level2' type="text" class="form-control" id="city"
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.city" name="city"
                 #city="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="form-label" for="state">State/ Province</label>
          <div class="input-group">
            <p-dropdown autocomplete='address-level1' [(ngModel)]="selectedAccountCopy.state" 
                        [filter]="true" [inputId]="'state'" iuiDropdown
                        placeholder="Select" [style]="{'width': '100%'}" #state class="p-formcontrol"
                        id="state" iuiRegion [name]="'state'" [disabled]=!enableStateEdit()></p-dropdown>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="zipCode">Postal/ ZIP Code</label>
          <input autocomplete='postal-code' type="text" class="form-control" id="zipCode"
                 [(ngModel)]="selectedAccountCopy.zipCode" name="zipCode"
                 [pattern]="zipCodeValidatorPattern(selectedAccountCopy?.billingCountry)"
                 #zipCode="ngModel">
        </div>
      </div>

    </div>

    <div style= "margin-bottom: .5em;">
      <strong>Billing Contact Information</strong>
    </div>
    <div class="ui-g mb-3">
      <p-checkbox [(ngModel)]="sameAsAccount" name="sameAsAccount" binary="true" [disabled]="!accountBeingEdited" (onChange)="sameAsAccountInfo($event)"></p-checkbox><label for="sameAsAccount">Same as Account Contact Information</label>
    </div>
    <div class="ui-g">

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="required form-label" for="billingFirstName">Billing First Name</label>
          <input autocomplete='given-name' type="text" class="form-control" id="billingFirstName" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingFirstName"
                 name="billingFirstName" #billingFirstName="ngModel">

        </div>

        <div class="mb-3">
          <label class="required form-label" for="billingLastName">Billing Last Name</label>
          <input autocomplete='family-name' type="text" class="form-control" id="billingLastName" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingLastName"
                 name="billingLastName" #billingLastName="ngModel">

        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="required form-label" for="billingEmail">Billing Email Address</label>
          <input autocomplete='email' type="text" class="form-control" id="billingEmail" required emailvalidator
                 [(ngModel)]="selectedAccountCopy.billingEmail"
                 name="billingEmail" placeholder="email@domain.com" #billingEmail="ngModel">
        </div>

        <div class="mb-3">
          <label class="required form-label" for="billingPhone">Billing Telephone Number</label>
          <input autocomplete='tel-national' type="text" class="form-control" id="billingPhone" required
                  [(ngModel)]="selectedAccountCopy.billingPhone" minlength="7"
                 name="billingPhone" #billingPhone="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3 required">
          <label class="required form-label" for="billingCountry">Billing Country</label>
          <div class="input-group">
            <p-dropdown [(ngModel)]="selectedAccountCopy.billingCountry"  [filter]="true"
                        [inputId]="'billingCountry'"
                        placeholder="Select" [required]="true" [style]="{'width': '100%'}" #billingCountry
                        autocomplete='country-name' iuiDropdown
                        class="p-formcontrol" id="billingCountry" iuiCountry [region]="billingState"
                        [name]="'billingCountry'" [disabled]="!accountBeingEdited"></p-dropdown>
          </div>
        </div>

        <div class="mb-3">
          <label class="required form-label" for="billingAddress1">Billing Address 1</label>
          <input autocomplete='address-line1' type="text" class="form-control" id="billingAddress1" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingAddress1"
                 name="billingAddress1" placeholder="street address" #billingAddress1="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

        <div class="mb-3">
          <label class="form-label" for="billingAddress2">Billing Address 2</label>
          <input autocomplete='address-line2' type="text" class="form-control" id="billingAddress2"
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingAddress2"
                 name="billingAddress2" placeholder="suite, floor, etc." #billingAddress2="ngModel">
        </div>

        <div class="mb-3">
          <label class="required form-label" for="billingCity">Billing City</label>
          <input autocomplete='address-level2' type="text" class="form-control" id="billingCity" required
                 [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingCity"
                 name="billingCity" #billingCity="ngModel">
        </div>

      </div>

      <div class="ui-g-2">

          <div class="mb-3">
              <label [ngClass]="{'required':(selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry == 'Canada')}" class="form-label" for="billingState">Billing State/ Province</label>
              <div class="input-group">
                <p-dropdown [(ngModel)]="selectedAccountCopy.billingState"  [filter]="true" 
                  [inputId]="'billingState'" [name]="'billingState'" iuiDropdown
                  placeholder="Select" [required]="selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry === 'Canada'"  
                  [style]="{'width': '100%'}" #billingState autocomplete='address-level1'
                  class="p-formcontrol" id="billingState" iuiRegion [disabled]=!enableBillingStateEdit()>
                </p-dropdown>
              </div>
            </div>

        <div class="mb-3">
          <label
            [ngClass]="{'required':(selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry == 'Canada')}"
            class="form-label" for="billingZipCode">Billing Postal/ ZIP Code</label>
          <input autocomplete='postal-code' type="text" class="form-control" id="billingZipCode"
                 [required]="selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry === 'Canada'"
                 [pattern]="zipCodeValidatorPattern(selectedAccountCopy?.billingCountry)"
                 [(ngModel)]="selectedAccountCopy.billingZipCode" name="billingZipCode"
                 #billingZipCode="ngModel">
        </div>

      </div>
    </div>
  </fieldset>

  <div class="ui-g edit-buttons">
    <div class="ui-g-6" *ngIf="!accountBeingEdited">
      <a [routerLink]="" class="edit-link" (click)="enableAccountEdit()">Edit Account</a>
    </div>
    <div class="ui-g-6" *ngIf="accountBeingEdited">
      <button id="btn-edit-account-save" [disabled]="!isAccountFormValid()"
              [class]="'width-150px btn ' + (!isAccountFormValid() ? 'btn-disabled' : 'btn-default')"
              (click)="saveAccount()">
        Save
      </button>
      <button id="btn-edit-account-cancel" class=" width-150px btn btn-secondary" (click)="cancelAccountEdit()">Cancel
      </button>
    </div>
  </div>

  <div class="tier-header">
    <label [class]="selectedAccountCopy.accountType === ACCOUNT_TYPE_STANDARD ? 'required':''">
      <strong>Monthly Fee Schedule</strong>
    </label>
  </div>
  <div class="ui-g">
    <div class="ui-g-6">
      <fee-schedule *ngIf="selectedAccountCopy.accountType === ACCOUNT_TYPE_STANDARD"
                    [(selectedTier)]="tier" [disabled]="!tierBeingEdited" ></fee-schedule>
      <custom-fee-schedule *ngIf="selectedAccountCopy.accountType === ACCOUNT_TYPE_NON_STANDARD"
                           [(customTier)]="customTier" [disabled]="true"></custom-fee-schedule>
    </div>

  </div>


  <div class="ui-g edit-buttons mt-2">
    <div class="ui-g-6" *ngIf="isAllowedToEditTier()">
      <a [routerLink]="" class="edit-link" (click)="enableTierEdit()">Edit Monthly Fee Schedule</a>
    </div>
    <div class="ui-g-6" *ngIf="tierBeingEdited">
      <button id="btn-edit-tier-save" [disabled]="!isTierFormValid()"
              [class]="'width-150px btn ' + (!isTierFormValid() ? 'btn-disabled' : 'btn-default')" (click)="saveTier()">
        Save
      </button>
      <button id="btn-edit-tier-cancel" class="btn btn-secondary width-150px" (click)="cancelTierEdit()">Cancel</button>
    </div>
  </div>
</form>
